import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_afb-presidentiel/artifacts/34q34hzr_LOGO%20FINIE%20AFB.png";

// Official logo component. The provided badge contains the full visual identity:
// 4 stars, RDC map, Président, AFB acronym & devise.
// `variant` controls how prominent it appears.
export const Logo = ({ size = 56, withText = true, dark = false, variant = "row" }) => {
  if (variant === "badge") {
    return (
      <img
        src={LOGO_URL}
        alt="Logo officiel A.F.B. — Les Amis de Fatshi Béton"
        style={{ width: size, height: size }}
        className="object-contain drop-shadow-[0_8px_24px_rgba(212,175,55,0.45)]"
        data-testid="afb-logo-badge"
      />
    );
  }

  const textColor = dark ? "text-white" : "text-[#0A0F1A]";
  const subColor = dark ? "text-[#D4AF37]" : "text-[#0052CC]";

  return (
    <div className="flex items-center gap-3" data-testid="afb-logo">
      <img
        src={LOGO_URL}
        alt="Logo officiel A.F.B."
        style={{ width: size, height: size }}
        className="object-contain shrink-0"
      />
      {withText && (
        <div className="leading-tight">
          <div className={`font-display font-bold text-base md:text-lg ${textColor}`}>
            LES AMIS DE FATSHI BÉTON
          </div>
          <div className={`text-[9px] md:text-[10px] uppercase tracking-[0.28em] font-semibold ${subColor}`}>
            Unité — Progrès — Travail
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
